import { bake_cookie, read_cookie, delete_cookie } from 'sfcookies';

const cookieName = 'vizfm.com';
const days = 365;
let userDetails = undefined;

const setCookie = (user, day=days) => {
    
    let d = new Date();
    d.setTime(d.getTime() + (day*24*60*60*1000));
    //date.setTime(date.getTime()+(days*24*60*60*1000));
    console.log('Set Cookie', user, d, day);
    bake_cookie(cookieName, user, d.toGMTString());
    userDetails = user
};

const getCookie = () => {
    let result = read_cookie(cookieName);
    console.log('Get Cookie', result);
    return result;
};

const removeCookie = () => {
    delete_cookie(cookieName);
    console.log('Delete Cookie');
};

const setUserDetails = (user) =>{
    console.log('No Cookie storing locally', user);
    userDetails = user;
}

const getUserDetails = () =>{
    console.log('No Cookie getting from locally', userDetails);
    return userDetails;
}

export { getCookie, removeCookie, setCookie, setUserDetails, getUserDetails}; 